import { tsBulkActionsGet } from '../../util/api'
import type { CustomFieldEntityType } from './types'

const SEARCH_ENDPOINT: Record<CustomFieldEntityType, string> = {
    campaign: 'campaigns/search',
    ad_group: 'ad-groups/search',
    target: 'targets/search',
    ad: 'product-ads/search',
}

const ID_FIELD: Record<CustomFieldEntityType, string> = {
    campaign: 'campaign_id',
    ad_group: 'ad_group_id',
    target: 'target_id',
    ad: 'ad_id',
}

/** Matches MAX_ID_LOOKUP in ts-bulk-actions/src/services/search-handler.ts. */
const MAX_IDS_PER_REQUEST = 200

const fetchNamesChunk = async (
    profileId: string,
    entityType: CustomFieldEntityType,
    entityIds: string[],
): Promise<Record<string, string>> => {
    const response = await tsBulkActionsGet(
        SEARCH_ENDPOINT[entityType],
        { entity_ids: entityIds.join(',') },
        { headers: { profileid: profileId } },
    )
    const idField = ID_FIELD[entityType]
    const names: Record<string, string> = {}
    for (const item of response.data.data as Array<Record<string, string>>) {
        names[item[idField]] = item.name
    }
    return names
}

export const fetchEntityNames = async (
    profileId: string,
    entityType: CustomFieldEntityType,
    entityIds: string[],
): Promise<Record<string, string>> => {
    if (entityIds.length === 0) return {}
    const chunks: string[][] = []
    for (let i = 0; i < entityIds.length; i += MAX_IDS_PER_REQUEST) {
        chunks.push(entityIds.slice(i, i + MAX_IDS_PER_REQUEST))
    }
    const results = await Promise.all(
        chunks.map((chunk) => fetchNamesChunk(profileId, entityType, chunk)),
    )
    return Object.assign({}, ...results)
}
